export const GENERATE_REPORT = "GENERATE_REPORT";
export const GENERATE_REPORT_SUCCESS = "GENERATE_REPORT_SUCCESS";
export const GENERATE_REPORT_FAIL = "GENERATE_REPORT_FAIL";

export const OPEN_AI_REFINE_TEXT = "OPEN_AI_REFINE_TEXT";
export const OPEN_AI_REFINE_TEXT_SUCCESS = "OPEN_AI_REFINE_TEXT_SUCCESS";
export const OPEN_AI_REFINE_TEXT_FAIL = "OPEN_AI_REFINE_TEXT_FAIL";

export const STORE_REFINED_TEXT = "STORE_REFINED_TEXT";
export const STORE_REFINED_TEXT_SUCCESS = "STORE_REFINED_TEXT_SUCCESS";
export const STORE_REFINED_TEXT_FAIL = "STORE_REFINED_TEXT_FAIL";

export const GET_REFIENED_PROGRESS_NOTES_LIST = "GET_REFIENED_PROGRESS_NOTES_LIST";
export const GET_REFIENED_PROGRESS_NOTES_LIST_SUCCESS = "GET_REFIENED_PROGRESS_NOTES_LIST_SUCCESS";
export const GET_REFIENED_PROGRESS_NOTES_LIST_FAIL = "GET_REFIENED_PROGRESS_NOTES_LIST_FAIL";

export const UPDATE_REPORT = "UPDATE_REPORT";
export const UPDATE_REPORT_SUCCESS = "UPDATE_REPORT_SUCCESS";
export const UPDATE_REPORT_FAIL = "UPDATE_REPORT_FAIL";

export const DELETE_REPORT = "DELETE_REPORT";
export const DELETE_REPORT_SUCCESS = "DELETE_REPORT_SUCCESS";
export const DELETE_REPORT_FAIL = "DELETE_REPORT_FAIL";

export const GET_REPORT_LOGS = "GET_REPORT_LOGS";
export const GET_REPORT_LOGS_SUCCESS = "GET_REPORT_LOGS_SUCCESS";
export const GET_REPORT_LOGS_FAIL = "GET_REPORT_LOGS_FAIL";

export const APPROVE_REPORT = "APPROVE_REPORT";
export const APPROVE_REPORT_SUCCESS = "APPROVE_REPORT_SUCCESS";
export const APPROVE_REPORT_FAIL = "APPROVE_REPORT_FAIL";

export const REPORT_ATTACHMENT_LIST = "REPORT_ATTACHMENT_LIST";
export const REPORT_ATTACHMENT_LIST_SUCCESS = "REPORT_ATTACHMENT_LIST_SUCCESS";
export const REPORT_ATTACHMENT_LIST_FAIL = "REPORT_ATTACHMENT_LIST_FAIL";

export const SAVE_REPORT_ATTACHMENT = "SAVE_REPORT_ATTACHMENT";
export const SAVE_REPORT_ATTACHMENT_SUCCESS = "SAVE_REPORT_ATTACHMENT_SUCCESS";
export const SAVE_REPORT_ATTACHMENT_FAIL = "SAVE_REPORT_ATTACHMENT_FAIL";

export const DELETE_REPORT_ATTACHMENT = "DELETE_REPORT_ATTACHMENT";
export const DELETE_REPORT_ATTACHMENT_SUCCESS = "DELETE_REPORT_ATTACHMENT_SUCCESS";
export const DELETE_REPORT_ATTACHMENT_FAIL = "DELETE_REPORT_ATTACHMENT_FAIL";

export const GET_TASK_REPORT_DETAIL = "GET_TASK_REPORT_DETAIL";
export const GET_TASK_REPORT_DETAIL_SUCCESS = "GET_TASK_REPORT_DETAIL_SUCCESS";
export const GET_TASK_REPORT_DETAIL_FAIL = "GET_TASK_REPORT_DETAIL_FAIL";

export const SET_REPORT_PAGINATION = "SET_REPORT_PAGINATION";
